import { render, staticRenderFns } from "./InfoDialog.vue?vue&type=template&id=89999a08"
import script from "./InfoDialog.vue?vue&type=script&lang=ts"
export * from "./InfoDialog.vue?vue&type=script&lang=ts"
import style0 from "./InfoDialog.vue?vue&type=style&index=0&id=89999a08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports